import { Box, Button, Flex, Heading, Tooltip } from '@chakra-ui/react';
import { QuantityPicker } from '@sphere/ui';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';

interface Props {
  onChange: (quantity: number) => void;
  max: number;
  quantity?: number;
  tooltipText?: string;
}

export const QuantityPickerBox = ({ onChange, max, quantity, tooltipText }: Props) => {
  const { t } = useTranslation('nft');

  return (
    <Box p="space.16" bg="gray.2" rounded="radius.8">
      <Flex align="center" gap="space.4" mb="space.8">
        <Heading fontSize="sm" as="h3">
          {t('components.quantity-picker-box.items-available')}
        </Heading>
        <Tooltip
          label={t('components.quantity-picker-box.select-max')}
          placement="top"
          hasArrow
          arrowSize={8}
        >
          <Button
            onClick={() => onChange(max)}
            variant="clear"
            fontWeight="medium"
            h="unset"
            minW="unset"
            p={0}
            _hover={{ opacity: 0.4 }}
          >
            {max}
          </Button>
        </Tooltip>
      </Flex>
      <Flex>
        <QuantityPicker
          value={quantity}
          size={rem(44)}
          max={max}
          onChange={onChange}
          textStyles={{ fontSize: 'md', fontWeight: 'medium' }}
          mr="space.8"
          tooltipText={tooltipText}
        />
      </Flex>
    </Box>
  );
};
